import type { Table } from "@tanstack/react-table";
import { interval } from "../../lib/utils";
import { Skeleton } from "../skeleton";
import { TableBody, TableCell, TableRow } from "../table";

const SKELETON_ROW_COUNT = 10;

type TableLoadingRowsProps<T extends { id: unknown }> = {
  table: Table<T>;
  rowCount?: number;
};

export const TableLoadingRows = <T extends { id: unknown }>({
  table,
  rowCount = SKELETON_ROW_COUNT,
}: TableLoadingRowsProps<T>) => {
  const cols = table.getVisibleFlatColumns();
  const count = cols.length || SKELETON_ROW_COUNT;

  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={cols.length}>
          <div className="min-h-[300px] flex flex-col justify-center gap-4">
            {interval(rowCount).map((rowNum) => (
              <div key={`skeleton-row-${rowNum}`} className="flex gap-4">
                {interval(count).map((_, index) => (
                  <div
                    key={`skeleton-cell-${rowNum}-${index.toString()}`}
                    className="flex-1"
                  >
                    <Skeleton className="h-3" />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};
